<script>
import { markRaw } from 'vue';

import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import MixinList from '@/Libs/Mixins/List.js';

import FilterFormSidebar from './Part/FilterFormSidebar.vue';

export default {
    mixins: [MixinList],
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            filterFormSidebar: markRaw(FilterFormSidebar),

            routeName: 'branch-session',
        }
    },
    methods: {
        async _search() {
            return await this.$api.BranchSession.all(this.search);
        },
        // ======
        load() {
            if (!this.$route) return;

            this.search = { ...this.$route.query };

            this.$orderBy.reset(this.search);

            if (Object.keys(this.$route.query).length > 0) {
                this._doSearch();
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('branch_session.title.list')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="g-4 align-items-center mb-3">
            <BCol sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                    <btn-sidebar variant="primary"
                        v-if="($ac.hasAccess('session_full_access') || ($ac.hasAccess('session_list')))"
                        :sidebar="filterFormSidebar" :success="onSubmitFilter">
                        <i class="mdi mdi-magnify align-bottom me-1"></i> {{ $t('branch_session.btn.search') }}
                    </btn-sidebar>
                </div>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="12">
                <BCard no-body>
                    <BCardBody>
                        <div>
                            <div class="table-responsive table-card position-relative">
                                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark"
                                    type="block">
                                    <table class="table align-middle table-hover table-nowrap mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                                <th>{{ $t('branch_session.label.date') }}</th>
                                                <th>{{ $t('branch_session.label.store') }}</th>
                                                <th>{{ $t('branch_session.label.branch') }}</th>
                                                <th>{{ $t('branch_session.label.signin') }}</th>
                                                <th>{{ $t('branch_session.label.signout') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tr, index) in list" :key="index" class="cursor-pointer" @click="
                                                ($ac.hasAccess('stuff_available_full_access') || ($ac.hasAccess('stuff_available_list') && ($ac.hasAccessStore(tr.store_id) || $ac.hasAccessBranch(tr.branch_id)))) &&
                                                ($router.push({
                                                    name: 'stuff-available', query: {
                                                        store_id: tr.store_id,
                                                        branch_id: tr.branch_id,
                                                        date: tr.date,
                                                        time_from: $dateFormat.cTime(tr.sign_in),
                                                        time_to: $dateFormat.cTime(tr.sign_out),
                                                    }
                                                }))">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ tr.date }}</td>
                                                <td>
                                                    {{ tr.store }}
                                                    <br><span class="text-body-secondary">{{ tr.store_ref_no }}</span>
                                                </td>
                                                <td>
                                                    {{ tr.branch }}
                                                    <br><span class="text-body-secondary">{{ tr.branch_ref_no }}</span>
                                                </td>
                                                <td>{{ tr.sign_in }}</td>
                                                <td>{{ tr.sign_out }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </loading>
                            </div>
                        </div>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
        <BRow class="mb-3">
            <BCol>
                <div>
                    <pagination v-bind:model="paginator" v-on:goto="goto"
                        :disabled="$loading.get([routeName, 'list'].join('_'))" />
                </div>
            </BCol>
        </BRow>
    </Layout>
</template>